/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Media for light/regular mode.
 * @export
 * @interface MediaTypeRegular
 */
export interface MediaTypeRegular {
    /**
     * URL to the icon for the provider.
     * @type {string}
     * @memberof MediaTypeRegular
     */
    iconURL?: string;
    /**
     * URL to the logo for the provider.
     * @type {string}
     * @memberof MediaTypeRegular
     */
    logoURL?: string;
}

/**
 * Check if a given object implements the MediaTypeRegular interface.
 */
export function instanceOfMediaTypeRegular(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MediaTypeRegularFromJSON(json: any): MediaTypeRegular {
    return MediaTypeRegularFromJSONTyped(json, false);
}

export function MediaTypeRegularFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaTypeRegular {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iconURL': !exists(json, 'iconURL') ? undefined : json['iconURL'],
        'logoURL': !exists(json, 'logoURL') ? undefined : json['logoURL'],
    };
}

export function MediaTypeRegularToJSON(value?: MediaTypeRegular | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iconURL': value.iconURL,
        'logoURL': value.logoURL,
    };
}

